import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as S from '../../styles';
import { DIALOGS } from '../../TransportCloudTable.consts';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
};

export const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  const { t } = useTranslation(['misc']);

  return (
    <S.ConfirmDeleteStyledDialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('modal.deleteEntityHeading', { ns: 'misc' })}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ fontSize: '0.8rem' }}>
          {DIALOGS.confirmDelete}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <S.TCStyledButton $primary disabled={loading} onClick={onConfirm}>
          {t('button.delete', { ns: 'misc' })}
        </S.TCStyledButton>
        <S.TCStyledButton disabled={loading} onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </S.TCStyledButton>
      </DialogActions>
    </S.ConfirmDeleteStyledDialog>
  );
};
